module.exports = __webpack_public_path__ + "img/mini-program-h5-clean.1b884adf.png";